import React, { Fragment } from 'react';

function Professional() {
	return (
		<Fragment>
			<div class="professional" id="professionalSection">
				<h2>Teaching Experience</h2>
				<div class="experience">
					<div class="block">
						<p><b>Instructor</b> | Northwestern University</p>
						<p>COMP_SCI 396: Computing, Ethics, and Society</p>
						<ul>
							<li>A seminar course to facilitate critical dialogue on the ethics of technologies (i.e., considering the harms and benefits, how / why they were created in the first place, and how / to what ends they are used)</li>
							<li>Students were encouraged to apply what they learned throughout the course and think about how they might want to contribute to a just, technologically-mediated future</li>
						</ul>
					</div>
					<div class="block">
						<p><b>Teaching Assistant</b> | Northwestern University</p>
						<p>COMP_SCI 329: Human-Computer Interaction Studio</p>
						<ul>
							<li>Provided specialized feedback to students and graded assignments that introduced students to research in human-computer interaction</li>
						</ul>
					</div>
					<div class="block">
						<p><b>Co-instructor</b> | Northwestern University</p>
						<p>Computing Everywhere Seminar Course: Data Visualization</p>
						<ul>
							<li>Students were introduced to principles of effective visualization design and tools used to create such visualizations</li>
							<li>This class was composed of short lectures with hands-on activities using ggplot2, a data visualization package for the programming language R</li>
						</ul>
					</div>
					<div class="block">
						<p><b>Instructional Aide</b> | College of Engineering, University of Michigan</p>
						<p>EECS 376: Foundations of Computer Science</p>
						<ul>
							<li>Core Computer Science course with a focus on the theory of computation</li>
							<li>Led weekly discussion and office hours, and participated in homework/exam writing and grading</li>
						</ul>
					</div>
					<div class="block">
						<p><b>Instructional Aide</b> | School of Information, University of Michigan</p>
						<p>SI 339: Web Design, Development, and Accessibility</p>
						<p>SI 539: Design of Complex Websites</p>
						<ul>
							<li>Built auto graders for both undergraduate and graduate level web design/development courses</li>
							<li>Helped to automate the testing process for websites and provide feedback to students</li>
						</ul>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export { Professional }